import { Component, input, Input, InputSignal, OnInit } from '@angular/core';
import { Column, ColumnType } from '../../models/simple-table-model';

@Component({
  selector: 'app-mobile-table',
  templateUrl: './mobile-table.component.html',
  styleUrls: ['./mobile-table.component.scss'],
})
export class MobileTableComponent implements OnInit {
  readonly ColumnType = ColumnType;

  columns: InputSignal<Column[]> = input<Column[]>([]);
  actions: InputSignal<any[]> = input<any[]>([]);
  data: InputSignal<any[]> = input<any[]>([]);

  isOpen = false;
  displayedColumns: Column[];
  hidedColumns: Column[];

  ngOnInit(): void {
    const nonComponentColumns = this.columns().filter((col) => !col.component);
    const localColumns = JSON.parse(JSON.stringify(nonComponentColumns));
    this.displayedColumns = localColumns.splice(0, 2);
    this.hidedColumns = localColumns;
  }
}
